import { ReactElement } from 'react'

import { OrderItem } from '../../redux/order'
import { ReportUmbracoData } from '../../containers/CompanyDetail/Reports'
import { Domain, DomainType } from '../../redux/domains'

export type CartItemProps = {
  data: OrderItem
  domainsData: Partial<Record<DomainType, Domain>>
  umbracoData?: ReportUmbracoData
  displayProductDescription?: boolean
}

export type StyledFieldProps = {
  label: string
  value?: string | ReactElement
}

export type ErrorFieldPros = {
  errorMessage?: string
} & StyledFieldProps

export type DescriptionFieldProps = {
  label: string
  value?: string
}

export type ReportDetailRes = {
  data: ReportUmbracoData[]
}

export const requiredDomains = [DomainType.Culture, DomainType.DeliveryOption]
